import React from 'react'
import Modal from 'react-bootstrap/Modal'
import { Popup } from '../../../../library/popup'
import { useDispatch, useSelector } from 'react-redux'
import { changeClientsModal, requestDeleteSingleClient, resetActiveClientDeletion } from '../../../../../redux/actions/clients'
import { TransparentButton, SolidButton } from '../../../../library/button'

import './style.scss'

const Index = () => {

    const dispatch = useDispatch()

    const modalState = useSelector(state => state.clients.showModals.deleteModal)
    const companyId = useSelector(state => state && state.activeCompany && state.activeCompany.activeCompany && state.activeCompany.activeCompany.id)

    const activeDeletion = useSelector(state => state.clients.activeDeletion)
	const loading = useSelector(state => state.clients.deleteClient.loading)

    const handleClose = () => {
        dispatch(changeClientsModal({deleteModal: false}))
        dispatch(resetActiveClientDeletion())
    }

    const clickDeleteClient = () => {
        dispatch(requestDeleteSingleClient({key: activeDeletion.id, type: activeDeletion.type, companyId: companyId}))
    }

    return(
        <Popup 
            onClose={handleClose}
            show={modalState} 
            title="Vil du slette denne kunden?"
			description="Dersom du sletter kunden vil den bli fjernet permanent og vil ikke være mulig å gjenopprette."
            buttons={[
                <TransparentButton title="Avbryt" type="button" data-dismiss="modal" onClick={() => handleClose()} />,
                <SolidButton color="red" title={loading ? "Sletter..":"Ja, slett kunden"} icon={loading ? <i className="fas fa-circle-notch fa-spin"></i>:<i class="fad fa-trash-alt"/>} onClick={() => clickDeleteClient()} type="button"/>
            ]}
        />
    )
}

export default Index


